export default __webpack_public_path__ + "static/media/Poppins-Thin.5a1918af.ttf";